"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.FieldIcon = exports.ChipBox = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _utils = require("@superlogica/foundation/utils");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Label = _styledComponents.default.span.withConfig({
  componentId: "sc-s9sows-0"
})(["display:flex;"]);

exports.Label = Label;

var FieldIcon = _styledComponents.default.i.withConfig({
  componentId: "sc-s9sows-1"
})([""]);

exports.FieldIcon = FieldIcon;

var ChipBox = _styledComponents.default.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['color', 'appearance'].includes(prop);
  }
}).withConfig({
  componentId: "sc-s9sows-2"
})(["", ""], function (_ref) {
  var size = _ref.size,
      color = _ref.color,
      theme = _ref.theme;
  return "\n    display: inline-flex;\n    padding-top:".concat(size.padding.top, "px;\n    padding-right:").concat(size.padding.right, "px;\n    padding-bottom:").concat(size.padding.bottom, "px;\n    padding-left:").concat(size.padding.left, "px;\n    border-radius: ").concat(size.borderRadius, ";\n    background: ").concat(_tokens.colors[color.color + color.scale], ";\n    & ").concat(Label, "{\n      color: ").concat((0, _utils.textContrast)(_tokens.colors[color.color + color.scale]), ";\n      font-family: ").concat(theme.fonts.default, ", sans-serif;\n      font-weight: ").concat(size.label.fontWeight, ";\n      font-size: ").concat(size.label.fontSize, "px;\n      letter-spacing: ").concat(size.label.letterSpacing, "px;\n      line-height: ").concat(size.label.lineHeight, "px;\n    }\n    & ").concat(FieldIcon, "{\n      display: flex;\n      svg {\n        width: ").concat(size.icon.width, "px;\n        height: ").concat(size.icon.height, "px;\n        margin-right: ").concat(size.icon.margin, "px;\n      }\n    }\n  ");
});

exports.ChipBox = ChipBox;